import { StudentEducationLevelSchema } from '@duke-hq/svc-api-db/schemas/enums/StudentEducationLevel.schema';
import { StudentGenderKindSchema } from '@duke-hq/svc-api-db/schemas/enums/StudentGenderKind.schema';
import { StudentDisabilitiesSchema } from '@duke-hq/svc-api-db/schemas/enums/StudentDisabilities.schema';
import { StatesSchema } from '@duke-hq/svc-api-db/schemas/enums/States.schema';

import { t } from '@lingui/core/macro';

export function getGenderOptions() {
  return [
    {
      label: t`Prefer not to say`,
      value: StudentGenderKindSchema.enum.PREFER_NOT_TO_SAY,
    },
    { label: t`Non-binary`, value: StudentGenderKindSchema.enum.NONBINARY },
    { label: t`Male`, value: StudentGenderKindSchema.enum.MALE },
    { label: t`Female`, value: StudentGenderKindSchema.enum.FEMALE },
  ];
}

export function getDisabilitiesOptions() {
  return [
    {
      label: t`Vision`,
      value: StudentDisabilitiesSchema.enum.VISION,
    },
    {
      label: t`Hearing/deaf`,
      value: StudentDisabilitiesSchema.enum.HEARING_DEAF,
    },
    {
      label: t`Physical`,
      value: StudentDisabilitiesSchema.enum.PHYSICAL,
    },
    {
      label: t`Intellectual`,
      value: StudentDisabilitiesSchema.enum.INTELLECTUAL,
    },
    {
      label: t`Learning`,
      value: StudentDisabilitiesSchema.enum.LEARNING,
    },
    {
      label: t`Mental illness`,
      value: StudentDisabilitiesSchema.enum.MENTAL_ILLNESS,
    },
    {
      label: t`Acquired brain impairment`,
      value: StudentDisabilitiesSchema.enum.ACQUIRED_BRAIN_INJURY,
    },
    {
      label: t`Medical condition`,
      value: StudentDisabilitiesSchema.enum.MEDICAL_CONDITION,
    },
    {
      label: t`Other`,
      value: StudentDisabilitiesSchema.enum.OTHER,
    },
    {
      label: t`Unspecified`,
      value: StudentDisabilitiesSchema.enum.UNSPECIFIED,
    },
  ];
}

export function getSchoolLevelOptions() {
  return [
    {
      label: t`Year 12 or equivalent`,
      value: StudentEducationLevelSchema.enum.YEAR_12_OR_EQUIVALENT,
    },
    {
      label: t`Year 11 or equivalent`,
      value: StudentEducationLevelSchema.enum.YEAR_11_OR_EQUIVALENT,
    },
    {
      label: t`Year 10 or equivalent`,
      value: StudentEducationLevelSchema.enum.YEAR_10_OR_EQUIVALENT,
    },
    {
      label: t`Year 9 or equivalent`,
      value: StudentEducationLevelSchema.enum.YEAR_9_OR_EQUIVALENT,
    },
    {
      label: t`Year 8 or below`,
      value: StudentEducationLevelSchema.enum.YEAR_8_OR_BELOW,
    },
    {
      label: t`Never attended school`,
      value: StudentEducationLevelSchema.enum.NEVER_ATTENDED_SCHOOL,
    },
  ];
}

export function getStatesOptions() {
  return [
    {
      label: t`Australian Capital Territory`,
      value: StatesSchema.enum.ACT,
    },
    {
      label: t`New South Wales`,
      value: StatesSchema.enum.NSW,
    },
    {
      label: t`Northern Territory`,
      value: StatesSchema.enum.NT,
    },
    {
      label: t`Queensland`,
      value: StatesSchema.enum.QLD,
    },
    {
      label: t`South Australia`,
      value: StatesSchema.enum.SA,
    },
    {
      label: t`Tasmania`,
      value: StatesSchema.enum.TAS,
    },
    {
      label: t`Victoria`,
      value: StatesSchema.enum.VIC,
    },
    {
      label: t`Western Australia`,
      value: StatesSchema.enum.WA,
    },
  ];
}
